/**
 * Surface tokens — the one definition of what the app's chrome looks like.
 *
 * The shell is dark everywhere: nav rail, filter rail, mobile menu, bottom nav,
 * the visits panel, the AI briefing and every settings screen. Four content
 * pages were not — List, Profile, Dashboard and Admin Hub were built light, so
 * moving between the map and the list crossed a hard light/dark seam.
 *
 * These are Tailwind class strings rather than CSS variables because the
 * components are written in Tailwind; the point is that a page composes from
 * here instead of picking its own greys. Adding a colour inline is exactly how
 * the four pages drifted in the first place.
 */
export const S = {
  /** Full-page background behind a view. */
  page: 'bg-gray-900',
  /** A raised card or panel sitting on the page. */
  card: 'bg-gray-800',
  /** A recessed well inside a card — table headers, preview blocks. */
  well: 'bg-gray-900/50',
  /** Hover state for an interactive row or card. */
  hover: 'hover:bg-gray-700/50',

  /** Border on a card or panel. */
  border: 'border-gray-700',
  /** Border on a form control, which needs a little more contrast. */
  borderStrong: 'border-gray-600',
  /** Divider between rows or sections. */
  divide: 'divide-gray-700',

  /** Headings and primary values. */
  title: 'text-gray-100',
  /** Body copy. */
  body: 'text-gray-300',
  /** Secondary text: labels, captions, column headers. */
  muted: 'text-gray-400',
  /** Tertiary text: hints, timestamps, empty-state copy. */
  faint: 'text-gray-500',

  /** Small caps section label. */
  label: 'text-[10px] font-bold uppercase tracking-wider text-gray-500',
  /** The brand band used at the top of panels and settings screens. */
  headerBand: 'bg-gradient-to-r from-blue-900 to-purple-900',
};

/** Text input, select and textarea. They need an explicit background: with none
 *  they fall back to the browser's white, which is invisible on a dark page. */
export const inputClass =
  'w-full px-3 py-2 rounded-lg bg-gray-800 border border-gray-600 text-gray-50 ' +
  'placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500';

export default S;
